import { map } from 'ramda'
import type { Params, SellPoints } from 'app/common/components/Cafeteria/dataTypes/customer/sellPoints'

import type { Request } from '../../../index'


type ApiParams = {
  customer_id: number
  school_id: number
}

export const convertParams = ({ customerID, orgID }: Params): [ApiParams, null] => {
  return [{
    customer_id: parseInt(customerID, 10),
    school_id: parseInt(orgID, 10),
  }, null]
}

type ApiResult = Record<string, {
  id: number
  title: string
  building_title: string
  building_id: number
  for_order: boolean
}>

export const convertResult = (res: ApiResult): SellPoints => {
  return map(({
    id,
    title,
    building_title: buildingTitle,
    building_id: buildingID,
    for_order: forOrder,
  }) => ({
    ID: String(id),
    title,
    buildingTitle,
    buildingID: String(buildingID),
    forOrder,
  }), res)
}

export const GET_CAFETERIA_CUSTOMER_SELL_POINTS: Request<Params, SellPoints, void> = [
  'cafeteria/customer/sale_points',
  'get',
  ['data', 'sale_points'],
]
